// extracted by mini-css-extract-plugin
export default {"container":"style_container__flW1Z","content":"style_content__4p1Dx","notFoundArea":"style_notFoundArea__A9sPi"};